import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mataudittrails',
  templateUrl: './mataudittrails.component.html',
  styleUrls: ['./mataudittrails.component.scss']
})
export class MataudittrailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
